module.exports = __webpack_public_path__ + "static/media/teaser-schneetage.95a169c3.jpg";